import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { useMemo } from 'react';

import {
  getShipsDirectlyFromNoteLead,
  getShipsFromNoteLead,
  getShipsToCountryText,
  MARKETPLACE_SHIPPING_NOTE_LEAD,
} from '../../../constants/marketplace';
import { ShipsFromNoteVariantEnum } from '../../../types/marketplace';
import { stripTrailingPeriod } from '../../../util/marketplace';

interface IProps {
  vendor?: string;
  variant?: ShipsFromNoteVariantEnum;
  brandCount?: number;
  countryLabel?: string;
}

const noteSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
  p: 1.5,
  borderRadius: 0.5,
  backgroundColor: ({ palette }) => alpha(palette.info.main, palette.action.selectedOpacity),
};

const iconSx: SxProps<Theme> = { fontSize: 20, color: 'info.main', flexShrink: 0 };

const emphasisSx: SxProps<Theme> = { fontWeight: 'medium' };

export const ShipsFromNote: React.FC<IProps> = ({
  vendor,
  variant = ShipsFromNoteVariantEnum.Vendor,
  brandCount,
  countryLabel,
}) => {
  const lead = useMemo(() => {
    if (variant === ShipsFromNoteVariantEnum.Brands) {
      return getShipsDirectlyFromNoteLead(brandCount ?? 0, vendor && stripTrailingPeriod(vendor));
    }
    if (variant === ShipsFromNoteVariantEnum.AllPartners) {
      return MARKETPLACE_SHIPPING_NOTE_LEAD;
    }

    return getShipsFromNoteLead(stripTrailingPeriod(vendor ?? 'our partner'));
  }, [variant, vendor, brandCount]);

  return (
    <Box sx={noteSx}>
      <LocalShippingOutlinedIcon sx={iconSx} />
      <Typography variant="body2" color="text.primary">
        {lead}{' '}
        <Box component="span" sx={emphasisSx}>
          {getShipsToCountryText(countryLabel)}
        </Box>
      </Typography>
    </Box>
  );
};
